export enum CapturumBuilderType {
  page = 'page',
  form = 'form',
  list = 'list',
}
